var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FBFBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26823_58881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 19C29 13.4772 24.5228 9 19 9C13.4772 9 9 13.4771 9 19C9 23.9913 12.6569 28.1284 17.4375 28.8785V21.8906H14.8984V19H17.4375V16.7969C17.4375 14.2906 18.9305 12.9063 21.2146 12.9063C22.3088 12.9063 23.4531 13.1016 23.4531 13.1016V15.5625H22.1922C20.9498 15.5625 20.5625 16.3334 20.5625 17.1242V19H23.3359L22.8926 21.8906H20.5625V28.8785C25.3431 28.1284 29 23.9913 29 19Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8926 21.8906L23.3359 19H20.5625V17.1242C20.5625 16.3333 20.9499 15.5625 22.1922 15.5625H23.4531V13.1016C23.4531 13.1016 22.3088 12.9062 21.2146 12.9062C18.9305 12.9062 17.4375 14.2906 17.4375 16.7969V19H14.8984V21.8906H17.4375V28.8785C17.9544 28.9595 18.4768 29.0001 19 29C19.5232 29.0002 20.0456 28.9595 20.5625 28.8785V21.8906H22.8926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26823_58881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7b6fa4f8bef0b0f617d4a21b6c6a25b.svg";
export { ForwardRef as ReactComponent };